import React from 'react';
import styled from 'styled-components';
import { Flex } from '../shared/Flex';
import ErrorIcon from '../../assets/error-icon.svg';

const Wrapper = styled(Flex)`
  position: absolute;
  top: 0;
  width: 100%;
  justify-content: start;
  align-items: center;
  background-color: white;
  z-index: 9999;
  padding: 10px 20px;
`;

const Message = styled.div`
  padding: 0 20px 0 10px;
  font-size: 14px;
  color: #231f20;
  text-align: left;
`;

const Icon = styled.img`
  margin-left: 30px;
`;

const ErrorAlert = ({ message }) => {
  if (!message) {
    return null;
  }

  console.log(message);
  return (
    <Wrapper>
      <Icon src={ErrorIcon} />
      <Message>Intenta nuevamente</Message>
    </Wrapper>
  );
};
export default ErrorAlert;
